import React, { useState, useEffect, useContext, useRef } from 'react';

// import useSound from 'use-sound';
// import se_07_scan from '../sound/s07_scan.mp3';
// import se_08 from '../sound/s08_se_delay0.mp3';


import { zxingQRScan } from '../components/ZxingQRScanUtil';
import { SharedInfoContext } from '../components/SharedInfoContextProvider';
import { useUserAPI } from '../components/useUserAPI';
import { iAeonGetPayBarCode } from '../library/iaeon_sdk.js';
import { iAeonGetPointBarCode } from '../library/iaeon_sdk.js';
import { iAeonGetMemberInfo } from '../library/iaeon_sdk.js';
import { useSDK } from "../scandit/sdk";
import { iAeonSetData } from '../library/iaeon_sdk.js';

// PayModal はお会計〜QRScanner遷移までのOTB取得・会員情報取得等のバックグラウンド処理のみを担い、
// モーダルUIは表示しない（お会計ボタン押下で直接QRScanner画面へ遷移する仕様のため）
export const PayModal = (props) => {

const { loaded, sdk } = useSDK();

// const [se07_scan] = useSound(se_07_scan);
// const [se08_se] = useSound(se_08);


// const { otbCode, updateOtbCode } = useContext(SharedInfoContext);
const sharedInfo = useContext(SharedInfoContext);
const { terminalCode, updateTerminalCode } = useContext(SharedInfoContext);
//AeonPay連携 0:未許可 1:許可
const { aeonPayFlg, updateAeonPayFlg } = useContext(SharedInfoContext);
//AEON Pay連携バージョン確認：5.1.0より小さい 連携なし（暫定版）、5.1.0以上 連携可能（連携版）
const { aeonPayVerCheck, updateAeonPayVerCheck } = useContext(SharedInfoContext);

//9.WAON POINTバーコード取得API（決済API、決済予約APIで使用 → 未使用
// function callAPI_9(){
// 	console.log("REACT_APP_IAEON_FLG: " + process.env.REACT_APP_IAEON_FLG);
// 	if(process.env.REACT_APP_IAEON_FLG === "true"){
// 		let successCall_9 = function(success){
// 			// var aaa = JSON.stringify(success);
// 			var aaa = success;
// 			console.log('【iAeonGetPointBarCode】success：' + aaa);
// 			console.log('【iAeonGetPointBarCode】code：' + aaa.code);
// 			// updateOtbCode(aaa.code);
// 			props.setOtb(aaa.code);
// 			// goQRScan();
// 		}
// 		let errorCall_9 = function(error){
// 			// var bbb = JSON.stringify(error);
// 			var bbb = error;
// 			console.log('【iAeonGetPointBarCode】error: ' + error.error_code + " : " + error.message);
// 			// setErrFlg(true);
// 			// var error_msg = ";["+error.error_code+"];"+error.message+";;;";
// 			// setErr([true, error.error_code, error_msg]);
// 			// goQRScan();
// 		}
// 		iAeonGetPointBarCode().then(successCall_9).catch(errorCall_9);
// 	}else {
// 		// goQRScan();
// 	}
// }

//9.WAON POINTバーコード取得API（決済API、決済予約APIで使用 → 使用
// function callAPI_9_scan(){
// 	console.log("REACT_APP_IAEON_FLG: " + process.env.REACT_APP_IAEON_FLG);
// 	if(process.env.REACT_APP_IAEON_FLG === "true" && props.otb === ""){
// 		let successCall_9 = function(success){
// 			props.setOtbErr(false);
// 			//OTB取得失敗の動作確認用
// 			// props.setOtbErr(true);
// 			var aaa = success;
// 			console.log('【iAeonGetPointBarCode re】success：' + aaa);
// 			console.log('【iAeonGetPointBarCode re】code：' + aaa.code);
// 			// updateOtbCode(aaa.code);
// 			props.setOtb(aaa.code);
// 			goQRScan();
// 		}
// 		let errorCall_9 = function(error){
// 			props.setOtbErr(true);
// 			console.log('【iAeonGetPointBarCode re】error: ' + error.error_code + " : " + error.message);
// 			goQRScan();
// 		}
// 		iAeonGetPointBarCode().then(successCall_9).catch(errorCall_9);
// 	}else {
// 		props.setOtbErr(false);
// 		//OTB取得失敗の動作確認用
// 		// props.setOtbErr(true);
// 		goQRScan();
// 	}
// }


//----------------------------------------
//お支払いへ進む
//----------------------------------------

const retryCountRef = useRef(0); // リトライ回数を保持
const retryTimeout = useRef(null); // setTimeout のIDを保持
const shouldCancelRetryRef = useRef(false); // リトライ中断フラグ（stale closure 対策）

// `props.otb` が更新されたら即座に遷移（ボタンが押された場合のみ）
useEffect(() => {
	if (props.isWaitingForOtb === true && props.otb !== "") {
		// リトライループを確実に止める（stale closure 対策: ref で管理）
		shouldCancelRetryRef.current = true;
		if (retryTimeout.current) {
			clearTimeout(retryTimeout.current);
			retryTimeout.current = null;
		}

		if(props.otb === "error"){
			console.log('【useEffect】 OTB エラー検知。API を実行: ' + props.otb);
			fetchOtb();
		}else{
			console.log('【useEffect】 OTB 取得検知 → 即遷移: ' + props.otb);
			//OTB取得失敗の動作確認用（3箇所
			// props.setOtbErr(true);
			goQRScan();
		}
	}
}, [props.otb, props.isWaitingForOtb]); // `props.otb` と `isWaitingForOtb` の変化を監視


useEffect(() => {
	console.log("props.isButtonDisabled: "+props.isButtonDisabled);
}, [props.isButtonDisabled]);

//ログアップロードAPI
const { loguploadAPI, data: loguploadData, loading: loguploadLoading, error: loguploadError } = useUserAPI();

//お支払いボタン
function callAPI_9_scan() {
	console.log("props.isButtonDisabled: "+props.isButtonDisabled);
	if (props.isButtonDisabled === true){
		console.log("siharai_btn:skip");
		return; // すでにボタンが無効化されていたら処理をスキップ
	}else {
		props.setSoundState("se08_se");
		console.log("REACT_APP_IAEON_FLG: " + process.env.REACT_APP_IAEON_FLG);

		// ボタンをクリックしたので無効化
		props.setIsButtonDisabled(true);
		// ボタンがクリックされたのでフラグを true に設定（ここから `props.otb` の変化を監視）
		props.setIsWaitingForOtb(true);

		//ログアップロードAPI
		loguploadAPI(sharedInfo.transactionno,"siharai_btn:click");

		if (process.env.REACT_APP_IAEON_FLG === "true") { // iAEON有効
			// すでに OTB を取得済みなら API を実行せずに遷移
			if (props.otb) {
				if(props.otb === "error"){
					// console.log('【useEffect】 OTB エラー検知。API を実行222: ' + props.otb);
					// fetchOtb();
					return;
				}else{
					//OTB取得失敗の動作確認用（3箇所
					// props.setOtbErr(true);
					console.log('【callAPI_9_scan】 OTB 取得済み → setIsWaitingForOtb(true) の変化を useEffect が検知して goQRScan() へ: ' + props.otb);
					// setIsWaitingForOtb(true) の state 変化を useEffect が検知して goQRScan() を呼び出す
					// ここで直接呼ぶと useEffect との二重呼び出しになる
					return;
				}
			}

			// OTB 取得中なら最大20回リトライ（500msごと）
			if (props.isFetchingOtb) {
				retryCountRef.current = 0; // カウントをリセット
				shouldCancelRetryRef.current = false; // 中断フラグをリセット
				retryOtbCheck();
				return;
			}

			// OTB が未取得なら API を実行
			fetchOtb();
		} else { // iAEON無効
			goQRScan();
		}
	}
}

// お会計ボタン押下（props.showPayModal = true）を検知したら、
// 「お支払いへ進む」ボタン押下時と同じ処理を自動的に開始する（モーダルUIは表示しないため）
useEffect(() => {
	if (props.showPayModal === true) {
		callAPI_9_scan();
	}
}, [props.showPayModal]);

// OTB 取得中のチェック（最大20回リトライ）
// shouldCancelRetryRef を ref で管理することで stale closure を回避
function retryOtbCheck() {
	if (shouldCancelRetryRef.current) {
		console.log("【retryOtbCheck】 中断フラグ検知 → リトライ終了");
		return;
	}
	if (retryCountRef.current < 20) {
		console.log(`【retryOtbCheck】 OTB 取得待ち中... リトライ: ${retryCountRef.current + 1}`);
		retryCountRef.current += 1;
		retryTimeout.current = setTimeout(retryOtbCheck, 500);
	} else {
		console.log("【retryOtbCheck】 OTB 取得失敗。API を実行");
		fetchOtb();
	}
}

//iAeonGetPointBarCode 再取得
function fetchOtb() {
	console.log("----------------------------");
	console.log("【iAeonGetPointBarCode Re】call");
	//ログアップロードAPI
	loguploadAPI(sharedInfo.transactionno,"iAeonGetPointBarCode Re:call");

	iAeonGetPointBarCode()
		.then((success) => {
			props.setOtbErr(false);
			//OTB取得失敗の動作確認用（3箇所
			// props.setOtbErr(true);
			console.log('【iAeonGetPointBarCode Re】success：' + success);
			console.log('【iAeonGetPointBarCode Re】code：' + success.code);
			//ログアップロードAPI
			loguploadAPI(sharedInfo.transactionno,"iAeonGetPointBarCode Re:success, code:" + success.code);
			props.setOtb(success.code);
			// OTB が取得できた場合、`isWaitingForOtb` が `true` なら `useEffect` で `goQRScan()` が実行される

			//OTB取得失敗の動作確認用（3箇所
			// props.setOtbErr(true);
			// props.setOtb("43iAEONOTB_NG0000000000000000000");
		})
		.catch((error) => {
			props.setOtbErr(true);
			//OTB取得失敗時 固定文字列設定
			props.setOtb("43iAEONOTB_NG0000000000000000000");
			console.log('【iAeonGetPointBarCode Re】error: ' + error.error_code + " : " + error.message);
			//ログアップロードAPI
			loguploadAPI(sharedInfo.transactionno,"iAeonGetPointBarCode Re:error, error_code:" + error.error_code + ", message:" + error.message);
			// setOtb() の変化を useEffect が検知して goQRScan() を呼び出すため、ここでの直接呼び出しは不要
			// （直接呼び出すと useEffect との二重呼び出しになり ZXING 時に干渉が発生する）
		});
}

//ログアップロードAPI レスポンス
useEffect(() => {
	if(loguploadData){
		console.log(loguploadData);
		if (loguploadData.isSuccess == true) { //SUCCESS
			console.log(`【loguploadAPI】 isSuccess: ${loguploadData.isSuccess}`);
		}else{ //ERROR
			console.log(`【loguploadAPI】 isSuccess: ${loguploadData.isSuccess}`);
			console.log(`【loguploadAPI】 errorCode: ${loguploadData.errorCode}`);
			console.log(`【loguploadAPI】 errorMessage: ${loguploadData.errorMessage}`);
		}
	}
}, [loguploadData]);


//----------------------------------------
//決済用バーコード取得API（決済API、決済予約APIで使用 → 使用せず
//----------------------------------------

//17.決済用バーコード取得API（決済API、決済予約APIで使用 → 使用せず
function callAPI_17(){
    let successCall_17 = function(success){
        // var aaa = JSON.stringify(success);
        var aaa = success;
		console.log('【iAeonGetPayBarCode】success：' + aaa);
		console.log('【iAeonGetPayBarCode】code：' + aaa.code);
		// updateOtbCode(aaa.code);
    }
    let errorCall_17 = function(error){
        // var bbb = JSON.stringify(error);
		var bbb = error;
		console.log('【iAeonGetPayBarCode】error: ' + error.error_code + " : " + error.message);
		// setErrFlg(true);
		// var error_msg = ";["+error.error_code+"];"+error.message+";;;";
		// setErr([true, error.error_code, error_msg]);
    }
    iAeonGetPayBarCode().then(successCall_17).catch(errorCall_17);
}


//----------------------------------------
//お支払いモーダル表示時に、会員情報取得
//----------------------------------------

//2.会員情報取得API
function callAPI_2(tcode){
    let successCall_2 = function(success){
		// alert("【iAeonGetMemberInfo】success");
        // var aaa = JSON.stringify(success);
		console.log("----------------------------");
		console.log("【iAeonGetMemberInfo】");
        var aaa = success;
		console.log('【iAeonGetMemberInfo】success：' + aaa);
		console.log('【iAeonGetMemberInfo】aeon_memberid：' + aaa.aeon_memberid);
		// console.log('【iAeonGetMemberInfo】favorite_store：' + aaa.favorite_store);
		// console.log('【iAeonGetMemberInfo】favorite_store[0].code：' + aaa.favorite_store[0].code);
		console.log('【iAeonGetMemberInfo】aeonpay_flg：' + aaa.aeonpay_flg);
		// alert('【iAeonGetMemberInfo】aeon_memberid：' + aaa.aeon_memberid);
		// alert('【iAeonGetMemberInfo】aeonpay_flg：' + aaa.aeonpay_flg);

		//AeonPay連携 0:未許可 1:許可
		if(aaa.aeonpay_flg === "1"){ //連携ON
			updateAeonPayFlg("1");
		}else if(aaa.aeonpay_flg === "0"){ //連携OFF
			updateAeonPayFlg("0");
		}else { //未連携
			updateAeonPayFlg("undefined");
		}
		// updateTerminalCode(tcode);
		//18.データ保存API（端末番号保存
		// callAPI_18(tcode);
		//11.アプリケーション情報取得API
		// callAPI_11(tcode);
    }
    let errorCall_2 = function(error){
		// alert("【iAeonGetMemberInfo】error: " + error);
        // var bbb = JSON.stringify(error);
		var bbb = error;
		console.log('【iAeonGetMemberInfo】error: ' + error.error_code + " : " + error.message);
		props.setErrFlg(true);
		var error_msg = ";["+error.error_code+"];"+error.message+";;;";
		props.setErr([true, error.error_code, error_msg]);
    }
	console.log("----------------------------");
	console.log("【iAeonGetMemberInfo】call");
    iAeonGetMemberInfo().then(successCall_2).catch(errorCall_2);
}

//お支払いモーダル表示時に、会員情報取得
useEffect(() => {
	console.log("REACT_APP_IAEON_FLG: " + process.env.REACT_APP_IAEON_FLG);
	if(process.env.REACT_APP_IAEON_FLG === "true"){
		console.log("iAEON 有効");
		if(props.showPayModal === true){
			//17.決済用バーコード取得API（決済API、決済予約APIで使用
			// callAPI_17();
			//9.WAON POINTバーコード取得API（決済API、決済予約APIで使用
			// callAPI_9();
			//AEON Pay連携バージョン確認：5.1.0より小さい 連携なし（暫定版）、5.1.0以上 連携可能（連携版）
			if(sharedInfo.aeonPayVerCheck === true){ //5.1.0以上 連携可能（連携版）
				//2.会員情報取得API
				callAPI_2(sharedInfo.terminalCode);
			}
		}
	}
}, [props.showPayModal]);


//----------------------------------------
//QRスキャン（zxing・MLkit用
//----------------------------------------

const [QRcode, setQRcode] = useState('');

const { exitGateQR, updateExitGateQR } = useContext(SharedInfoContext);
const { signNumber, updateSignNumber } = useContext(SharedInfoContext);
const { registerNumber, updateRegisterNumber } = useContext(SharedInfoContext);
const { frontGateQR, updateFrontGateQR } = useContext(SharedInfoContext);
const { bandColor, updateBandColor } = useContext(SharedInfoContext);

const { saleslistAPI, data: saleslistData, loading: saleslistLoading, error: saleslistError } = useUserAPI();
const { payreserveAPI, data: payreserveData, loading: payreserveLoading, error: payreserveError } = useUserAPI();
const { payAPI, data: payData, loading: payLoading, error: payError } = useUserAPI();


//----------------------------------------
//売上一覧取得API：レスポンス（zxing・MLkit用
//----------------------------------------

useEffect(() => {
	// console.log("useEffect purchaseData");
	if(saleslistData){
		if (saleslistData.data) { //SUCCESS

			console.log(`【saleslistAPI】 sumIncludeTaxPrice: ${saleslistData.data.sumIncludeTaxPrice}`);
			console.log(`【saleslistAPI】 sumSellPrice: ${saleslistData.data.sumSellPrice}`);
			console.log(`【saleslistAPI】 sumItemCount: ${saleslistData.data.sumItemCount}`);

			//売上一覧：明細用
			props.setSaleData(saleslistData);

			console.log("QRコード判定（先頭2桁）: " + QRcode.substring(0, 2));
			if(QRcode.substring(0, 2) === "79"){ //代表レジ
				console.log("代表レジ");
				console.log(`【payreserveAPI】 registerNumber: ${QRcode}`);
				//ログアップロードAPI
				loguploadAPI(sharedInfo.transactionno,"payreserveAPI:otb, code:" + props.otb);

				payreserveAPI(QRcode,props.otb);
				//二重送信対応テスト
				//payreserveAPI(QRcode,props.otb);

			}else{ //専用レジ（個別レジ）・有人レジ
				console.log("専用レジ（個別レジ）・有人レジ");
				// const QRcode = "770000082900008730000009";
				// 15、16、17番目の文字を抽出
				const reginum = QRcode.substring(14, 17);
				console.log(`【payAPI】 registerNumber: ${reginum}`);
				updateRegisterNumber(reginum);
				//ログアップロードAPI
				loguploadAPI(sharedInfo.transactionno,"payAPI:otb, code:" + props.otb);

				payAPI(QRcode,props.otb);
				//二重送信対応テスト
				//payAPI(QRcode,props.otb);
			}
		}else{ //ERROR
			console.log(`【saleslistAPI】 errorCode: ${saleslistData.errorCode}`);
			console.log(`【saleslistAPI】 errorMessage: ${saleslistData.errorMessage}`);
			console.log(`【saleslistAPI】 isSuccess: ${saleslistData.isSuccess}`);

			if(saleslistData.errorCode === "26"){
				//トークン不正、トークン有効期限切れ のためエラー表示後にアプリ起動後の画面へ（再読込
				props.setErrFlg(true);
				props.setErr([true,`${saleslistData.errorCode}`, process.env.REACT_APP_ERROR_MESSAGE_26]);
				// props.setErr([true,`${saleslistData.errorCode}`,`i1b0;認証エラー;申し訳ございません。正常に処理が終了いたしませんでした。買い物を中止して、最初から操作しなおしてください。[26];Authentication Error;The authentication has expired or was invalid. Please tap to start the process again.[26]`]);
			}else if(saleslistData.errorCode === "27"){
				//トークン不正、トークン有効期限切れ のためエラー表示後にアプリ起動後の画面へ（再読込
				props.setErrFlg(true);
				props.setErr([true,`${saleslistData.errorCode}`, process.env.REACT_APP_ERROR_MESSAGE_27]);
				// props.setErr([true,`${saleslistData.errorCode}`,`i1b0;認証エラー;申し訳ございません。正常に処理が終了いたしませんでした。買い物を中止して、最初から操作しなおしてください。[27];Authentication Error;The authentication has expired or was invalid. Please tap to start the process again.[27]`]);
			}else if(saleslistData.errorCode === "32"){//フロントチェックエラー
				props.setErrFlg(true);
				props.setErr([true,`${saleslistData.errorCode}`,`${saleslistData.errorMessage}`]);
			}else{
				// props.setErrNum(`${saleslistData.errorCode}`);
				// props.setShowModal(true);
				// props.setErrTxt(`${saleslistData.errorMessage}`);
				props.setErrFlg(true);
				props.setErr([true,`${saleslistData.errorCode}`,`${saleslistData.errorMessage}`]);

			}
			//「お会計」ボタン有効化
			props.setIsKaikeiButtonDisabled(false);
			//「スキャン」ボタン有効化
			props.setIsScanButtonDisabled(false);
		}
	}
	if(saleslistError){
		console.log("saleslistError");
		console.log(saleslistError);
		props.setErrFlg(true);
		props.setErr([true,``, process.env.REACT_APP_ERROR_MESSAGE_TIMEOUT]);
		// props.setErr([true,``,`;通信エラー;サーバーからの応答がありませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
		// props.setErr([true,``,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);

		//「お会計」ボタン有効化
		props.setIsKaikeiButtonDisabled(false);
		//「スキャン」ボタン有効化
		props.setIsScanButtonDisabled(false);
	}
}, [saleslistData,saleslistLoading,saleslistError]);


//----------------------------------------
//決済予約API：代表レジ レスポンス取得（zxing・MLkit用
//----------------------------------------

useEffect(() => {
	// console.log("useEffect purchaseData");
	if(payreserveData){
		if (payreserveData.data) { //SUCCESS
			console.log(`【payreserveAPI】 qrcode: ${payreserveData.data.qrcode}`);
			console.log(`【payreserveAPI】 signNumber: ${payreserveData.data.signNumber}`);
			console.log(`【payreserveAPI】 registerNumber: ${payreserveData.data.registerNumber}`);
			if(process.env.REACT_APP_FRONT_CHECK === "true"){ //せき止め有効
				console.log(`【payreserveAPI】 dammingFlag: ${payreserveData.data.dammingFlag}`);
			}

			updateExitGateQR(payreserveData.data.qrcode);
			updateSignNumber(payreserveData.data.signNumber);
			updateRegisterNumber(payreserveData.data.registerNumber);

			setTimeout(function(){
				console.log(QRcode.substring(0, 2));
				if(QRcode.substring(0, 2) === "79"){ //代表レジ
					if(process.env.REACT_APP_FRONT_CHECK === "true"){ //せき止め有効
						if(payreserveData.data.dammingFlag === "1"){ //せき止めON
							goRegiSenyou(true);
						}else{ //せき止めOFF
							goRegiSenyou(false);
						}
					}else{ //せき止め無効
						goRegiSenyou(false);
					}
				}else{ //専用レジ（個別レジ）・有人レジ
					// if(exitGateQR === "999"){ //有人レジ
					console.log("QRcode.substring(12, 14): "+QRcode.substring(12, 14));
					if(QRcode.substring(12, 14) === "01"){ //有人レジ
						goRegiYujin();
					}else{ //専用レジ（個別レジ）へ
						goRegiSelf();
					}
				}
			}, 400);

		}else{ //ERROR
			console.log(`【payreserveAPI】 errorCode: ${payreserveData.errorCode}`);
			console.log(`【payreserveAPI】 errorMessage: ${payreserveData.errorMessage}`);
			console.log(`【payreserveAPI】 isSuccess: ${payreserveData.isSuccess}`);

			if(payreserveData.errorCode === "26"){
				//トークン不正、トークン有効期限切れ のためエラー表示後にアプリ起動後の画面へ（再読込
				props.setErrFlg(true);
				props.setErr([true,`${payreserveData.errorCode}`, process.env.REACT_APP_ERROR_MESSAGE_26]);
				// props.setErr([true,`${payreserveData.errorCode}`,`i1b0;認証エラー;申し訳ございません。正常に処理が終了いたしませんでした。買い物を中止して、最初から操作しなおしてください。[26];Authentication Error;The authentication has expired or was invalid. Please tap to start the process again.[26]`]);
				// console.log("エラー32：フロントチェックエラー");
				// props.setPage("error_32");
			}else if(payreserveData.errorCode === "27"){
				//トークン不正、トークン有効期限切れ のためエラー表示後にアプリ起動後の画面へ（再読込
				props.setErrFlg(true);
				props.setErr([true,`${payreserveData.errorCode}`, process.env.REACT_APP_ERROR_MESSAGE_27]);
				// props.setErr([true,`${payreserveData.errorCode}`,`i1b0;認証エラー;申し訳ございません。正常に処理が終了いたしませんでした。買い物を中止して、最初から操作しなおしてください。[27];Authentication Error;The authentication has expired or was invalid. Please tap to start the process again.[27]`]);
				// console.log("エラー32：フロントチェックエラー");
				// props.setPage("error_32");
			}else if(payreserveData.errorCode === "32"){//フロントチェックエラー
				// props.setErrFlg(true);
				// props.setErr([true,`${payreserveData.errorCode}`,`${payreserveData.errorMessage}`]);
				console.log("エラー32：フロントチェックエラー");
				props.setPage("error_32");
			}else{
				// props.setErrNum(`${payreserveData.errorCode}`);
				// props.setShowModal(true);
				// props.setErrTxt(`${payreserveData.errorMessage}`);
				props.setErrFlg(true);
				props.setErr([true,`${payreserveData.errorCode}`,`${payreserveData.errorMessage}`]);

			}
			//「お会計」ボタン有効化
			props.setIsKaikeiButtonDisabled(false);
			//「スキャン」ボタン有効化
			props.setIsScanButtonDisabled(false);
		}
	}
	if(payreserveError){ //通信エラー・タイムアウト（緑ルート
		console.log("payreserveError");
		console.log(payreserveError);
		// props.setErrFlg(true);
		// props.setErr([true,``,`;通信エラー;サーバーからの応答がありませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
		console.log("タイムアウト（ノーレスポンス）・通信エラーのため、エラー35画面へ");
		// props.setTimeoutCountFlg(true);
		// props.setPage("regi_self");
		props.setPage("error_35");
	}
}, [payreserveData,payreserveLoading,payreserveError]);


//----------------------------------------
//決済API：専用レジ（個別レジ）・有人レジ レスポンス取得（zxing・MLkit用
//----------------------------------------

useEffect(() => {
	// console.log("useEffect purchaseData");
	if(payData){
		if (payData.data) { //SUCCESS

			console.log(`【payAPI】 qrcode: ${payData.data.qrcode}`);

			updateExitGateQR(payData.data.qrcode);

			setTimeout(function(){
				console.log(QRcode.substring(0, 2));
				if(QRcode.substring(0, 2) === "79"){ //代表レジ
					//せき止め無効
					goRegiSenyou(false);
				}else{ //専用レジ（個別レジ）・有人レジ
					// if(exitGateQR === "999"){ //有人レジ
					console.log("QRcode.substring(12, 14): "+QRcode.substring(12, 14));
					if(QRcode.substring(12, 14) === "01"){ //有人レジ
						goRegiYujin();
					}else{ //専用レジ（個別レジ）へ
						goRegiSelf();
					}
				}
			}, 400);

		}else{ //ERROR
			console.log(`【payAPI】 errorCode: ${payData.errorCode}`);
			console.log(`【payAPI】 errorMessage: ${payData.errorMessage}`);
			console.log(`【payAPI】 isSuccess: ${payData.isSuccess}`);

			if(payData.errorCode === "26"){
				//トークン不正、トークン有効期限切れ のためエラー表示後にアプリ起動後の画面へ（再読込
				props.setErrFlg(true);
				props.setErr([true,`${payData.errorCode}`, process.env.REACT_APP_ERROR_MESSAGE_26]);
				// props.setErr([true,`${payData.errorCode}`,`i1b0;認証エラー;申し訳ございません。正常に処理が終了いたしませんでした。買い物を中止して、最初から操作しなおしてください。[26];Authentication Error;The authentication has expired or was invalid. Please tap to start the process again.[26]`]);
				// console.log("エラー32：フロントチェックエラー");
				// props.setPage("error_32");
			}else if(payData.errorCode === "27"){
				//トークン不正、トークン有効期限切れ のためエラー表示後にアプリ起動後の画面へ（再読込
				props.setErrFlg(true);
				props.setErr([true,`${payData.errorCode}`, process.env.REACT_APP_ERROR_MESSAGE_27]);
				// props.setErr([true,`${payData.errorCode}`,`i1b0;認証エラー;申し訳ございません。正常に処理が終了いたしませんでした。買い物を中止して、最初から操作しなおしてください。[27];Authentication Error;The authentication has expired or was invalid. Please tap to start the process again.[27]`]);
				// console.log("エラー32：フロントチェックエラー");
				// props.setPage("error_32");
			}else if(payData.errorCode === "32"){//フロントチェックエラー
				// props.setErrFlg(true);
				// props.setErr([true,`${payData.errorCode}`,`${payData.errorMessage}`]);
				console.log("エラー32：フロントチェックエラー");
				props.setPage("error_32");
			}else{
				// props.setErrNum(`${payData.errorCode}`);
				// props.setShowModal(true);
				// props.setErrTxt(`${payData.errorMessage}`);
				props.setErrFlg(true);
				props.setErr([true,`${payData.errorCode}`,`${payData.errorMessage}`]);
			}
			//「お会計」ボタン有効化
			props.setIsKaikeiButtonDisabled(false);
			//「スキャン」ボタン有効化
			props.setIsScanButtonDisabled(false);
		}
	}
	if(payError){ //通信エラー・タイムアウト（緑ルート
		console.log("payError");
		console.log(payError);
		// props.setErrFlg(true);
		// props.setErr([true,``,`;通信エラー;サーバーからの応答がありませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
		console.log("タイムアウト（ノーレスポンス）・通信エラーのため、エラー35画面へ");
		// props.setTimeoutCountFlg(true);
		// props.setPage("regi_self");
		props.setPage("error_35");
	}
}, [payData,payLoading,payError]);


//----------------------------------------
//ページ遷移（zxing・MLkit用
//----------------------------------------

//代表レジ
const goRegiSenyou = (dammingFlg) => {
	props.setRegiType("regi_senyou");

	if(process.env.REACT_APP_IAEON_FLG === "true"){ //iAEON有効
		//データ保存API（買物データ削除
		callAPI_18_delete();
	}

	if(process.env.REACT_APP_FRONT_CHECK === "true"){ //せき止め有効
		console.log("dammingFlg: " + dammingFlg);
		if(dammingFlg === true){ //せき止めON
			props.setPage("front_check");
		}else{ //せき止めOFF
			props.setPage("regi_senyou");
		}
	}else{ //せき止め無効
		props.setPage("regi_senyou");
	}
}

//専用レジ（個別レジ
const goRegiSelf = () => {
	props.setRegiType("regi_self");

	if(process.env.REACT_APP_IAEON_FLG === "true"){ //iAEON有効
		//データ保存API（買物データ削除
		callAPI_18_delete();
	}
	props.setPage("regi_self");
}

//有人レジ
const goRegiYujin = () => {
	props.setRegiType("regi_yujin");

	if(process.env.REACT_APP_IAEON_FLG === "true"){ //iAEON有効
		//データ保存API（買物データ削除
		callAPI_18_delete();
	}
	props.setPage("regi_yujin");
}


//----------------------------------------
//データ保存API（買物データ削除（zxing・MLkit用
//----------------------------------------

//18.データ保存API（買物データ削除
function callAPI_18_delete(){
	console.log("----------------------------");
	console.log("【iAeonSetData】post");
    let successCall_18 = function(success){
        // var aaa = JSON.stringify(success);
        // console.log('successCall：' + aaa);
		var aaa = success;
		console.log('【iAeonSetData】success：');
		console.log(aaa);
    }
    let errorCall_18 = function(error){
		var bbb = error;
		console.log('【iAeonSetData】error: ' + error.error_code + " : " + error.message);
		console.log(bbb);
    }
	iAeonSetData({"mode":"delete", "key": "shopping_data"}).then(successCall_18).catch(errorCall_18);
}


// Zxing用 -------------------------------


//----------------------------------------
//QRスキャン遷移
//----------------------------------------

const goQRScan = () => {
	console.log("REACT_APP_ZXING: " + process.env.REACT_APP_ZXING);
	if(process.env.REACT_APP_ZXING === "true"){ //ZXING QR有効
		console.log("ZXING QR有効");
		props.setShowPayModal(false);
		// console.log("zxing_result: " + zxing_result);
		zxingQRScan().then(data => {
			console.log("zxing_qr_result: " + data);
			props.setSoundState("se07_scan");

			setQRcode(data);
			updateFrontGateQR(data);
			updateRegisterNumber(data);

			//売上一覧取得API
			saleslistAPI();

		}).catch(error => {
			console.log("【iAeonDoCodeRead】error: ", error);
			console.log('【iAeonDoCodeRead】error: ' + error.error_code + " : " + error.message);

			props.setShowPayModal(false);
			props.setSoundState("se08_se");
			//「お会計」ボタン有効化
			props.setIsKaikeiButtonDisabled(false);
			//「スキャン」ボタン有効化
			props.setIsScanButtonDisabled(false);

			// props.setSoundState("se07_scan");
			// props.setErrFlg(true);
			// var error_msg = ";["+error.error_code+"];"+error.message+";;;";
			// props.setErr([true, error.error_code, error_msg]);
			// props.setErr([true, process.env.REACT_APP_ERROR_CODE_000018, process.env.REACT_APP_ERROR_MESSAGE_000018]);
			// props.setErr([true,`000018`,`;バーコード・QRコード読み取り失敗;;;;`]);
		});
		props.setSoundState("se08_se");

	}else{ //ZXING QR無効 → scandit QR有効
		console.log("scandit QR有効");
		//「お会計」ボタンを無効化
		props.setIsKaikeiButtonDisabled(true);
		// (async () => {
		// 	// await sdk.enableScanning(true);
		// 	await sdk.enableCamera(true);
		// })();
		props.setShowPayModal(false);
		setTimeout(function(){
			document.getElementById('header').classList.add('is_behind');
			props.setTimeoutCountFlg(false);
			props.setTimeoutCount(0);
			props.setPage("qrscan");
			// props.setScanActive("qrcode");
		}, 100);
		// }, 2000);
	}
}


// モーダルUIは表示しない（バックグラウンド処理専用コンポーネント）
return null;

}
